export default __webpack_public_path__ + "static/media/dg-coin.579ba2f9.webp";